'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _utils = require('reactstrap/lib/utils');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Vlastní implementace modálního dialogu kvůli překrytí stylu position relative na obalovací elementcelého dialogu
 * viz https://github.com/reactstrap/reactstrap/issues/529
 * viz https://github.com/reactstrap/reactstrap/issues/113
 */
var CustomModal = function (_Modal) {
    (0, _inherits3.default)(CustomModal, _Modal);

    function CustomModal() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CustomModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CustomModal.__proto__ || (0, _getPrototypeOf2.default)(CustomModal)).call.apply(_ref, [this].concat(args))), _this), _this.show = function () {
            var topWrapperClassName = _this.props.topWrapperClassName;

            var classes = document.body.className;
            _this._element = document.createElement('div');
            _this._element.setAttribute('tabindex', '-1');

            // this._element.style.position = 'relative';   // toto nechceme!
            if (topWrapperClassName) {
                _this._element.className = topWrapperClassName;
            }

            _this._element.style.zIndex = _this.props.zIndex;
            _this.originalBodyPadding = (0, _utils.getOriginalBodyPadding)();

            (0, _utils.conditionallyUpdateScrollbar)();

            document.body.appendChild(_this._element);

            document.body.className = (0, _utils.mapToCssModules)((0, _classnames2.default)(classes, 'modal-open'), _this.props.cssModule);

            _this.renderIntoSubtree();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    return CustomModal;
}(_reactstrap.Modal);

CustomModal.propTypes = {
    topWrapperClassName: _react2.default.PropTypes.string // classname divu, který kompletně obaluje dialog
};
exports.default = CustomModal;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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